// biome-ignore-all lint: this file will be gone soon
function binaryStringify(e: string) {
	return encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, (_, t) => String.fromCharCode(Number(`0x${t}`)));
}

function binaryDestringify(e: string) {
	return decodeURIComponent(
		e
			.split("")
			.map((e) => `%${(`00${e.charCodeAt(0).toString(16)}`).slice(-2)}`)
			.join(""),
	);
}
export function lzwEncode(input: string) {
	// Step 1: get a string where each char corresponds to one byte
	const binaryString = binaryStringify(input);

	// LZW dictionary and state
	const dict: Record<string, number> = {};
	const chars = binaryString.split("");
	const outputCodes: number[] = [];

	// current sequence we're accumulating
	let currentSequence = chars[0];
	let nextCode = 256; // next available dictionary code (0-255 reserved)

	// Process each following character
	for (let idx = 1; idx < chars.length; idx++) {
		const currentChar = chars[idx];

		// If currentSequence + currentChar is already in the dictionary,
		// extend the currentSequence with the character
		if (dict[currentSequence + currentChar] != null) {
			currentSequence += currentChar;
		} else {
			// Otherwise, emit the code for currentSequence (either the
			// single-byte char code or a dictionary code) and add the new
			// sequence to the dictionary.
			outputCodes.push(currentSequence.length > 1 ? dict[currentSequence] : currentSequence.charCodeAt(0));

			dict[currentSequence + currentChar] = nextCode;
			nextCode++;
			currentSequence = currentChar;
		}
	}

	// Emit the final sequence
	outputCodes.push(currentSequence.length > 1 ? dict[currentSequence] : currentSequence.charCodeAt(0));

	// Convert numeric codes into a compact textual form:
	// - Convert to base36 string
	// - For the final character of the base36 string:
	//   - If it's a digit 0-9 replace it with a symbol from encode_table
	//   - Otherwise uppercase it (so letters are A-Z)

	return outputCodes
		.map((lutNumber) => {
			const base36 = lutNumber.toString(36);
			const lastChar = base36[base36.length - 1];

			return (
				base36.substring(0, base36.length - 1) +
				(lastChar.match(/[0-9]/)
					? // @ts-expect-error, this is error is bad because we know last char is 0-9 from the regex and that's in the table
						encode_table[lastChar]
					: lastChar.toUpperCase())
			);
		})
		.join("");
}

const encode_table = {
	0: "=",
	1: "!",
	2: "?",
	3: "$",
	4: "%",
	5: "&",
	6: "/",
	7: "\\",
	8: "-",
	9: "+",
};
const decode_table = {
	"=": "0",
	"!": "1",
	"?": "2",
	$: "3",
	"%": "4",
	"&": "5",
	"/": "6",
	"\\": "7",
	"-": "8",
	"+": "9",
};
const punctuationKeys = Object.keys(decode_table).join("");

export function lzwDecode(encoded: string) {
	// Step 1: parse the encoded string back into numeric codes
	const codes: number[] = [];
	let buffer = "";

	for (let idx = 0; idx < encoded.length; idx++) {
		const ch = encoded[idx];

		// If ch is an uppercase letter (A-Z) or one of the punctuation
		// markers, we consider that the base36 token ended here.
		if (ch.match(/[A-Z]/) || punctuationKeys.includes(ch)) {
			// If it's one of our punctuation markers, map it back to the digit.
			// Otherwise lower-case the letter to recover the original base36
			// digit letter.
			buffer += punctuationKeys.includes(ch) ? decode_table[ch] : ch.toLowerCase();

			// Convert the collected base36 token to a number and push.
			codes.push(parseInt(buffer, 36));
			buffer = "";
		} else {
			// Part of a base36 token (not yet finished)
			buffer += ch;
		}
	}

	// Step 2: Standard LZW expansion of numeric codes back to a sequence of
	// strings. The decoder uses an initial dictionary with 0-255 mapping to
	// single-character strings.
	const dict: Record<number, string> = {};
	let previous = String.fromCharCode(codes[0]);
	let entry = previous;
	const outputStrings = [previous];
	let dictNextCode = 256;

	for (let i = 1; i < codes.length; i++) {
		const code = codes[i];
		let decodedEntry: string;

		if (code < 256) {
			// single-byte value
			decodedEntry = String.fromCharCode(code);
		} else {
			// code might exist in dict, or be the special KwKwK case
			decodedEntry = dict[code] ? dict[code] : previous + entry;
		}

		outputStrings.push(decodedEntry);

		// Add new dictionary entry: previous + first char of decodedEntry
		entry = decodedEntry[0];
		dict[dictNextCode] = previous + entry;
		dictNextCode++;

		previous = decodedEntry;
	}

	// Step 3: Combine all decoded pieces and turn the binary-safe string
	// back into the original Unicode string.
	return binaryDestringify(outputStrings.join(""));
}
